import { FunctionalComponent, h } from 'preact';
import { PaymentMode, PaymentState } from '../../../helpers/use-payments-helper';
import { i18nKeyValue } from '../../../i18n/strings/types';
import { ControlWrapper } from '../../control-wrapper';

interface Props {
    upiRegistrationFlowVariant: UpiRegistrationFlowVariant;
    langStrings: i18nKeyValue;
    onClickUpiBannerClick: () => void;
}

export enum UpiRegistrationFlowVariant {
    PRIMARY = 'PRIMARY',
    BACKUP = 'BACKUP',
}

export const UpiAutopayBanner: FunctionalComponent<Props> = (props: Props) => {
    const {
        upiRegistrationFlowVariant,
        langStrings,
        onClickUpiBannerClick,
    } = props;

    const isBackup = upiRegistrationFlowVariant === UpiRegistrationFlowVariant.BACKUP;
    const bannerMessage = isBackup ? langStrings?.Paymentsuccess_UPISetup_backupbanner_message1 : langStrings?.Paymentsuccess_UPISetup_primarybanner_message1;
    const [bannerMessageBefore, bannerMessageAfter] = (bannerMessage ?? '').split('UPI');
    const bannerMessageWithUpiImg = (
        <span>
            {bannerMessageBefore}
            <img src="/assets/images/upi-black.svg" alt="UPI" />
            {bannerMessageAfter}: 
        </span>
    );

    return (
        <div className="banner">
            <img src="/assets/images/upi-banner-bg.png" class="banner" alt="UPI" />

            <div className="banner-container"
                onClick={onClickUpiBannerClick}>

                <div className="banner-text">
                    {langStrings.upi_ap_homepage_trust_seal.replace('XXX', '15000+').toUpperCase()}
                </div>
                <div className="data-container">
                    <div className="title-text">
                        {bannerMessageWithUpiImg}
                        <div className="pending-text-container">
                            <img className="warning-icon" src="/assets/images/warning.svg" alt="Warning" /> {langStrings?.Paymentsuccess_UPISetup_backupbanner_message2}
                        </div>
                    </div>
                </div>
                <div className="cta-parent-container">
                    <div className="cta-container">
                        <span className="cta">
                            {langStrings?.upi_ap_banner_cta}
                        </span>
                    </div>
                </div>
                <div className="marquee-container">
                    <div className="marquee-content">
                        <span className="bottom-text">
                            {langStrings?.upi_ap_banner_ticker_1} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_2} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_3}
                        </span>
                    </div>
                </div>
            </div>

        </div >
    );
};
